/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable consistent-return */
/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import { useEffect, useState, useCallback, useRef } from "react";
import { Box } from "@mui/material";
import axios from "axios";
import expressConfig from "src/config/express.json";
import { useTour } from "src/context/global/TourContext";
import EXCHANGE_INSTAGRAM_TOKEN from "src/graphql/mutation/settings/exchangeInstagramToken";
import SUBSCRIBE_INSTAGRAM_PAGES from "src/graphql/mutation/settings/subscribeInstagramPages";
import ADD_PAGE from "src/graphql/mutation/settings/addPage";
import { useMutation, useLazyQuery } from "@apollo/client";
import NoRecordFound from "src/components/shared/molecules/NoRecordFound";
import GET_PAGES from "src/graphql/query/settings/getPages";
import useActiveUserDetail from "src/utils/shared/useActiveUserDetail";
import { useSnackbar } from "notistack";
import CircularProgress from "src/components/shared/atoms/circularProgress/CircularProgress";
import useStyle from "./Styles";
import InstagramIssuesModal from "./InstagramIssuesModal";
import UpperComponent from "./upperComponent";
import LowerComponent from "./lowerComponent";
import { User } from "../facebook/upperComponent/types";

interface ModalRefType {
  handleOpen: () => void;
}

interface ModalRefType2 {
  handleOpen: () => void;
}

const Instagram = () => {
  const env = process.env.NODE_ENV || "development";
  const config = expressConfig[env];

  const SOURCE = "instagram";
  const { enqueueSnackbar } = useSnackbar();

  const [loadingProcess, setLoadingProcess] = useState(false);

  // opening modal
  const modalRef = useRef<ModalRefType | null>(null);
  const handleOpen = () => modalRef.current?.handleOpen();

  const modalRef2 = useRef<ModalRefType2 | null>(null);
  const hasAutoOpened = useRef(false);

  const { classes } = useStyle();
  const [pagesData, setPagesData] = useState<any[]>([]);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const scrollRef = useRef<HTMLDivElement>(null);

  const [loggedInUserDetail, setloggedInUserDetail] = useState<User | null>(
    null,
  );
  const [pageExistingError, setPageExistingError] = useState<string | null>(
    null,
  );

  // handle existing pages error
  const handleExistingPagesError = (error: string) => {
    setPageExistingError(error);
  };

  const { startPostFbConnectionTour, guideData, guideLoading } = useTour();

  const { mainSuperAdminId } = useActiveUserDetail();

  //
  const [modifiedAddedPages, setModifiedAddedPages] = useState<any[]>([]);
  const [savedMetaId, setSavedMetaId] = useState("");

  const updatePagesFunc = useCallback(
    (pagesAray: any) => {
      setPagesData((prev: any[]) => {
        // Filter new page IDs that are not in the previous state
        const newPages = pagesAray.filter(
          (item: { pageId: any }) =>
            !prev.some((i: any) => i.pageId === item.pageId),
        );

        // Get removed page IDs for the logged-in user
        const removedPageIds = prev
          .filter(
            (item: { metaId: string; pageId: string }) =>
              item.metaId === savedMetaId,
          )
          .filter(
            (item: { pageId: string }) =>
              !pagesAray.some(
                (j: { pageId: string }) => j.pageId === item.pageId,
              ),
          )
          .map((item: { pageId: string }) => item.pageId);

        // Update the existing pages with the new `isSelected` status
        const updatedPages = prev.map((j: { pageId: any }) => {
          if (removedPageIds.includes(j.pageId)) {
            return {
              ...j,
              isSelected: false,
            };
          }
          return j;
        });

        // Return the combined array of new and updated pages
        return [...newPages, ...updatedPages];
      });
    },
    [modifiedAddedPages],
  );
  //

  const [
    addPages,
    { data: addPagesMutationResult, loading: addPagesMutationLoading },
  ] = useMutation(ADD_PAGE);

  const [exchangeToken] = useMutation(EXCHANGE_INSTAGRAM_TOKEN);
  const [subscribeInstagramPages] = useMutation(SUBSCRIBE_INSTAGRAM_PAGES);

  useEffect(() => {
    if (addPagesMutationResult && addPagesMutationResult.addpages) {
      const { success, error, result } = addPagesMutationResult.addpages;
      let successfullyAddedCount = 0;

      if (success === 0 && error) {
        handleExistingPagesError(error);

        let filteredPages = modifiedAddedPages;
        if (result) {
          try {
            const erroredIds = JSON.parse(result);
            if (Array.isArray(erroredIds)) {
              filteredPages = modifiedAddedPages.filter(
                (pageObj) => !erroredIds.includes(pageObj.pageId),
              );
            }
          } catch (e) {
            // Fallback to name-based filtering
            const erroredPages = error
              .split("has")[0]
              .split(",")
              .map((page: string) => page.trim());

            filteredPages = modifiedAddedPages.filter(
              (pageObj) => !erroredPages.includes(pageObj.name),
            );
          }
        }

        updatePagesFunc(filteredPages);
        successfullyAddedCount = filteredPages.length;
      } else {
        updatePagesFunc(modifiedAddedPages);
        successfullyAddedCount = modifiedAddedPages.length;
      }

      // Start tour if we actually connected at least one page
      if (
        successfullyAddedCount > 0 &&
        !guideData?.getUserGuide?.postFbConnectionCompleted
      ) {
        setTimeout(() => {
          startPostFbConnectionTour();
        }, 1000);
      }
    }
  }, [addPagesMutationResult, guideData]);

  // Auto-open instructions modal on first visit
  useEffect(() => {
    if (
      !guideLoading &&
      guideData?.getUserGuide?.facebookGuideCompleted === false &&
      !hasAutoOpened.current &&
      modalRef2.current
    ) {
      hasAutoOpened.current = true;
      modalRef2.current.handleOpen();
    }
  }, [guideLoading, guideData]);

  const getDetails = async (token: string) => {
    try {
      // Recursive helper to paginate through ALL Facebook pages to find Instagram accounts.
      type FbAccountsResponse = { data: any[]; paging?: { next?: string } };
      const fetchAllPages = async (
        url: string,
        accumulated: any[] = [],
      ): Promise<any[]> => {
        const { data: fbResponse }: { data: FbAccountsResponse } =
          await axios.get(url);
        const all = [...accumulated, ...(fbResponse.data || [])];
        return fbResponse.paging?.next
          ? fetchAllPages(fbResponse.paging.next, all)
          : all;
      };

      const initialUrl = `https://graph.facebook.com/v21.0/me/accounts?fields=id,name,access_token,instagram_business_account{id,profile_picture_url}&access_token=${token}`;
      const allPages = await fetchAllPages(initialUrl);
      return allPages || [];
    } catch (error: any) {
      console.log(
        "something went wrong in getDetails function while reading all instgram connected pages and other pages:\n",
        error,
      );
      enqueueSnackbar(
        error.response?.data?.error?.message || "Something went wrong",
        {
          variant: "error",
        },
      );
      return []; // Return empty array to prevent map() crash
    }
  };

  // Removed subscribeToInstagramWebhooks frontend function as it is now handled by backend

  // ?? Helper: Exchange short-lived token for long-lived token
  const exchangeForLongLivedToken = async (shortLivedToken: string) => {
    try {
      const { data } = await exchangeToken({
        variables: { shortLivedToken },
      });

      if (data?.exchangeInstagramToken?.success) {
        return data.exchangeInstagramToken.longLivedToken;
      }
      throw new Error(
        data?.exchangeInstagramToken?.error || "Token exchange failed",
      );
    } catch (error) {
      console.error("Token exchange mutation error:", error);
      throw error;
    }
  };

  useEffect(() => {
    const fetchData = async (longLivedToken: string) => {
      try {
        setLoadingProcess(true);

        // 1. Get user info
        const userRes = await axios.get(
          `https://graph.facebook.com/me?fields=id,name,email,picture.width(640).height(640)&access_token=${longLivedToken}`,
        );

        if (!userRes?.data) {
          enqueueSnackbar(
            "User details are missing. Please re-authorize the app.",
            { variant: "error" },
          );
          return;
        }

        setloggedInUserDetail(userRes.data);

        // 2. Get FB Pages + Instagram accounts
        const res: any = await getDetails(longLivedToken);

        const instagramLinkedPages = res.filter(
          (item: any) => item.instagram_business_account,
        );

        let successfulPages = instagramLinkedPages;

        if (instagramLinkedPages.length > 0) {
          // 3. Subscribe to webhooks via backend
          const { data: subscriptionResult } = await subscribeInstagramPages({
            variables: {
              pageIds: instagramLinkedPages.map((item: any) => item.id),
              accessTokens: instagramLinkedPages.map(
                (item: any) => item.access_token,
              ),
            },
          });

          if (subscriptionResult?.subscribeInstagramPages?.success === 0) {
            throw new Error(
              subscriptionResult.subscribeInstagramPages.error ||
                "Failed to subscribe pages",
            );
          }

          // ── Handle Partial Success ──────────────────────────────────────────
          const resultRaw = subscriptionResult?.subscribeInstagramPages?.result;
          if (resultRaw) {
            try {
              const { succeeded, failed } = JSON.parse(resultRaw);

              // Filter to only add successfully subscribed pages to CRM
              successfulPages = instagramLinkedPages.filter((p: any) =>
                succeeded.includes(p.id),
              );

              // Show detailed warnings for each failed page
              if (failed && failed.length > 0) {
                failed.forEach((failObj: { pageId: string; error: string }) => {
                  const pageName =
                    instagramLinkedPages.find(
                      (p: any) => p.id === failObj.pageId,
                    )?.name || failObj.pageId;

                  enqueueSnackbar(
                    `Failed to connect Instagram for "${pageName}": ${failObj.error}`,
                    {
                      variant: "warning",
                      autoHideDuration: 15000,
                    },
                  );
                });
              }
            } catch (e) {
              console.error("Failed to parse subscription result", e);
            }
          }
        }

        const addedPageObjectValue: any[] = [];

        // 4. Build page objects to store in DB
        successfulPages.forEach((item: any) => {
          addedPageObjectValue.push({
            name: item.name,
            pageId: item.instagram_business_account.id,
            accesstoken: item.access_token, // page access_token
            picture: item.instagram_business_account.profile_picture_url,
            mainSuperAdminId,
            source: SOURCE,
            email: userRes.data.email ?? null,
            metaId: userRes.data.id,
          });
        });

        // 5. Save pages or show "connect account" modal
        if (addedPageObjectValue.length > 0) {
          await addPages({
            variables: {
              input: addedPageObjectValue,
            },
            refetchQueries: [
              {
                query: GET_PAGES,
                variables: {
                  mainSuperAdminId,
                  source: "instagram",
                  onlySelected: false,
                },
              },
            ],
          });

          setModifiedAddedPages([...addedPageObjectValue]);
          setSavedMetaId(userRes.data.id);
        } else {
          handleOpen(); // show InstagramIssuesModal
        }
      } catch (error: any) {
        console.error("error_instagram__", error);
        enqueueSnackbar(error?.message || "Something went wrong", {
          variant: "error",
        });
      } finally {
        setLoadingProcess(false); // <<< stop loader when done
      }
    };

    const init = async () => {
      // Extract the hash params from redirect URL
      const hash = window.location.hash.substring(1); // remove "#"
      const paramsArray = hash.split("&");
      const paramsObject = paramsArray.reduce((acc: any, current: any) => {
        const [key, value] = current.split("=");
        acc[key] = decodeURIComponent(value);
        return acc;
      }, {});

      const shortLivedToken = paramsObject.access_token;

      if (shortLivedToken) {
        try {
          setLoadingProcess(true);
          const longLivedToken =
            await exchangeForLongLivedToken(shortLivedToken);
          await fetchData(longLivedToken);
        } catch (err) {
          console.error("Token exchange failed:", err);
          enqueueSnackbar("Failed to exchange token. Please try again.", {
            variant: "error",
          });
        } finally {
          // ? Remove access token from URL after process (success or failure)
          const cleanUrl = config.INSTAGRAM_LOGIN_FLOW_REDIRECT_URL;
          window.history.replaceState({}, document.title, cleanUrl);
          setLoadingProcess(false);
        }
      }
    };

    init();
  }, []);

  const [
    getPages,
    { loading: getPagesQueryLoading, data: getPagesQueryResult },
  ] = useLazyQuery(GET_PAGES, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    getPages({
      variables: {
        mainSuperAdminId,
        source: "instagram",
        onlySelected: false,
      },
    });
  }, [mainSuperAdminId, pageExistingError]);

  useEffect(() => {
    const pages: any = [];
    if (getPagesQueryResult?.getAllPages?.result?.length) {
      getPagesQueryResult.getAllPages.result.forEach(
        (curr: any, index: number) =>
          pages.push({
            order: index,
            ...curr,
          }),
      );
      setPagesData(pages);
    } else if (getPagesQueryResult?.getAllPages?.success === 0) {
      enqueueSnackbar(getPagesQueryResult.getAllPages.error, {
        variant: "error",
      });
      setPagesData([]);
    } else {
      setPagesData([]);
    }
  }, [getPagesQueryResult]);

  const handleScroll = () => {
    if (scrollRef.current) {
      const currentScroll = scrollRef.current.scrollTop;
      // Hysteresis: Collapse at 60px, only Expand back at < 10px for maximum stability
      if (currentScroll > 60) {
        setIsCollapsed(true);
      } else if (currentScroll < 10) {
        setIsCollapsed(false);
      }
    }
  };

  const [, setErrorBoxHeight] = useState<number>(0);

  return (
    <>
      <InstagramIssuesModal ref={modalRef} />
      <Box className={classes.rootBox} ref={scrollRef} onScroll={handleScroll}>
        <Box className={classes.decorationBlob} />

        {getPagesQueryLoading ? (
          <Box className={classes.loadingCircularProgressBox}>
            <CircularProgress />
          </Box>
        ) : (
          <Box
            sx={{
              position: "relative",
              zIndex: 1,
              // Guaranteed scroll room to prevent layout-driven scroll resets
              minHeight: "calc(100% + 200px)",
            }}
          >
            <Box className={classes.stickyHeader}>
              <UpperComponent
                modalRef={modalRef2}
                handleExistingPagesError={handleExistingPagesError}
                pageExistingError={pageExistingError}
                loggedInUserDetail={loggedInUserDetail}
                setloggedInUserDetail={setloggedInUserDetail}
                setErrorBoxHeight={setErrorBoxHeight}
                loading={addPagesMutationLoading || loadingProcess}
                isCollapsed={isCollapsed}
              />
            </Box>

            {!getPagesQueryLoading && pagesData.length > 0 && (
              <Box
                sx={{
                  // mt: isCollapsed ? 26 : 3,
                  mt: isCollapsed ? "100px" : "20px",
                  transition: "margin-top 0.45s cubic-bezier(0.4, 0, 0.2, 1)",
                }}
              >
                <LowerComponent
                  pagesData={pagesData}
                  setPagesData={setPagesData}
                />
              </Box>
            )}

            {!getPagesQueryLoading && pagesData.length === 0 && (
              <Box mt={10} display="flex" justifyContent="center">
                <NoRecordFound />
              </Box>
            )}
          </Box>
        )}
      </Box>
    </>
  );
};

export default Instagram;
